const versionConfig = {
    version: 'v1.2.0',
    manufactureDate: '2025-09',
}

export default versionConfig

